<template>
  <div class="space-bottom">
    <b-row class="align-items-center">
      <b-col md="4" cols="12">
        <div class="d-flex mt-2">
          <p class="mt-2 mr-3 f-18px">เลขที่เอกสาร</p>
          <InputText
            type="text"
            className=" bg-second flex-grow-1"
            placeholder="เลขที่"
            textField=""
            :value="form.document_no"
            disabled
          />
          <b-button class="ml-2" @click="printDoc(1)" v-if="id > 0">
            <font-awesome-icon icon="print" class="pointer text-white" />
          </b-button>
        </div>
      </b-col>
      <b-col md="2" cols="12">
        <div class="mt-2"></div>
      </b-col>
      <b-col md="6" cols="12">
        <div class="mt-2">
          <div
            class="mt-2 mr-2 title text-right d-flex align-items-center justify-content-end"
          >
            ผู้สร้าง :

            <InputText
              class="ml-2"
              placeholder="Staff No."
              readonly
              v-model="form.created_user_guid"
              @focus="showPin()"
              v-if="!require_pin_login == '0' && !form.created_user_guid"
            >
            </InputText>
            <div v-else class="ml-2">
              <div>
                {{ form.created_user_guid }} (
                {{ form.created_user_name }}
                {{
                  $moment(form.created_date)
                    .add(543, "years")
                    .format("DD/MM/YYYY")
                }}
                )
                <span class="text-link" v-if="id < 1 && !require_pin_login" @click="showPin()"
                  >เปลี่ยน</span
                >
              </div>
            </div>
            <div class="ml-2">
              สถานะ : {{ form.repairStatusName || "รับเข้าสาขา" }}
              <span
                :class="{
                  'text-success':
                    form.repair_user_transaction_id ||
                    (form.delivery_date && totalPrice == 0),
                  'text-error':
                    !form.repair_user_transaction_id ||
                    (!form.delivery_date && totalPrice == 0),
                }"
                v-if="form.repair_status_id == 2"
              >
                {{
                  form.repair_user_transaction_id
                    ? "(ชำระเงินแล้ว) "
                    : form.delivery_date && !totalPrice
                    ? "(ส่งมอบแล้ว)"
                    : totalPrice > 0 && !form.repair_user_transaction_id
                    ? "(ยังไม่ชำระเงิน)"
                    : "(ยังไม่ส่งมอบ)"
                }}
              </span>
            </div>
          </div>
          <p class="mt-2 mr-2 title text-right" v-if="form.billNo">
            หมายเลขใบเสร็จ :
            <span
              class="text-link"
              @click="
                $router.push(
                  `/transaction/detail/${form.repair_user_transaction_id}/${form.repair_owner_user_guid}/1`
                )
              "
              >{{ form.billNo }}</span
            >
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="8">
        <div class="d-flex align-items-center f-14">
          <p class="text-gray title-w">ชื่อลูกค้า</p>
          <p class="text-gray">:</p>
          <div class="display-user-value d-flex ml-2 justify-content-between">
            <div>{{ form.repair_owner_user_name }}</div>

            <div
              class="text-link"
              @click="clearName()"
              v-if="form.repair_owner_user_name && id < 1"
            >
              Clear
            </div>
          </div>
          <font-awesome-icon
            v-if="id == 0"
            @click="handleSearch(1)"
            :icon="['fas', 'search']"
            class="pointer fa-search text-white"
            id="search-icon"
          />
        </div>
        <div class="d-flex align-items-center mt-1 f-14">
          <p class="text-gray title-w">ชื่อผู้ส่งซ่อม</p>
          <p class="text-gray">:</p>
          <div class="display-user-value ml-2">
            {{ form.repair_send_user_name }}
          </div>
          <font-awesome-icon
            v-if="id == 0"
            @click="handleSearch(2)"
            :icon="['fas', 'search']"
            class="pointer fa-search text-white"
            id="search-icon"
          />
        </div>
        <!-- <div class="d-flex align-items-center mt-2 f-14">
          <p class="text-gray title-w">ชื่อผู้รับ</p>
          <p class="text-gray">:</p>
          <div class="display-user-value ml-2">
            {{ form.repair_reciever_user_name }}
          </div>
          <font-awesome-icon
            v-if="id == 0"
            @click="handleSearch(3)"
            :icon="['fas', 'search']"
            class="pointer fa-search text-white"
            id="search-icon"
          />
        </div> -->
        <div class="d-flex align-items-center mt-1 f-14">
          <p class="text-gray title-w f-14">วิธีการรับเงิน</p>
          <p class="text-gray">:</p>
          <b-button
            v-if="form.repair_status_id !== 2"
            class="ml-2 custom-btn"
            @click="selectRefundType()"
          >
            วิธีการรับเงิน
          </b-button>

          <p class="ml-2" v-if="form.user_return_payment_id">
            {{ form.user_return_payment.return_payment_name }} |
            {{ form.user_return_payment.return_bank_name }} เลขบัญชี
            {{ form.user_return_payment.bank_account_number }}
          </p>
        </div>
      </b-col>

      <b-col md="4" cols="12">
        <div class="d-flex align-items-center justify-content-end mt-2 f-14">
          <p class="text-gray title-w">เวลาที่คาดว่าจะเสร็จสิ้น</p>
          <p class="text-gray">:</p>
          <div class="datetime-container">
            <datetime
              :disabled="form.repair_status_id == 2"
              type="date"
              :format="'dd/MM/yyyy'"
              textFloat="วันหมดอายุใหม่"
              v-model="form.expect_finish_date"
              name="expire"
              class="datetime-h ml-2 custom-date-picker"
              value-zone="Asia/Bangkok"
              :class="['date-picker-input', 'date-filter']"
              :minDatetime="now"
            >
            </datetime>
            <div class="calendar-icon">
              <font-awesome-icon icon="calendar-alt" />
            </div>
          </div>
        </div>
        <div
          v-if="id !== '0'"
          class="d-flex align-items-center justify-content-end mt-2 f-14"
        >
          <div>
            <div
              class="d-flex align-items-center mt-2 f-14"
              v-if="form.inventoryTransferSend.createdFullName"
            >
              <p class="text-gray title-w">ผู้รับสินค้าจากคลัง</p>
              <p class="text-gray">:</p>
              <div class="ml-2">
                {{ form.inventoryTransferSend.createdFullName || "-" }}
                ({{
                  $moment(form.inventoryTransferSend.createdTime)
                    .add(543, "years")
                    .format("DD/MM/YYYY")
                }})
              </div>
            </div>
            <div
              class="d-flex align-items-center mt-2 f-14"
              v-if="form.inventoryTransferReturn.createdFullName"
            >
              <p class="text-gray title-w">ผู้จำหน่ายสินค้า</p>
              <p class="text-gray">:</p>
              <div class="ml-2">
                {{ form.inventoryTransferReturn.createdFullName || "-" }}
                ({{
                  $moment(form.inventoryTransferReturn.createdTime)
                    .add(543, "years")
                    .format("DD/MM/YYYY")
                }})
              </div>
            </div>
            <div
              class="d-flex align-items-center mt-2 f-14"
              v-if="form.inventoryTransferSend.documentNo"
            >
              <p class="text-gray title-w">เอกสารโอนออก</p>
              <p class="text-gray">:</p>
              <div
                class="ml-2 text-link"
                @click="
                  $router.push(
                    `/inventory-transfer/0/detail/${form.inventoryTransferSend.id}`
                  )
                "
              >
                {{ form.inventoryTransferSend.documentNo || "-" }}
              </div>
              <b-button class="ml-2" @click="printDoc(3)" v-if="id > 0">
                <font-awesome-icon icon="print" class="pointer text-white" />
              </b-button>
            </div>
            <div
              v-if="form.inventoryTransferReturn.documentNo"
              class="d-flex align-items-center mt-2 f-14"
            >
              <p class="text-gray title-w">เอกสารโอนกลับ</p>
              <p class="text-gray">:</p>
              <div
                class="ml-2 text-link"
                @click="
                  $router.push(
                    `/inventory-transfer/0/detail/${form.inventoryTransferReturn.id}`
                  )
                "
              >
                {{ form.inventoryTransferReturn.documentNo || "-" }}
              </div>
              <b-button class="ml-2" @click="printDoc(1)" v-if="id > 0">
                <font-awesome-icon icon="print" class="pointer text-white" />
              </b-button>
            </div>
            <div
              class="d-flex align-items-center mt-2 f-14"
              v-if="form.sell_back_scrap_gold_document_no"
            >
              <p class="text-gray title-w">ใบรับคืนเศษทอง</p>
              <p class="text-gray">:</p>
              <div class="ml-2">
                {{ form.sell_back_scrap_gold_document_no }}
              </div>
              <b-button class="ml-2" @click="printDoc(2)">
                <font-awesome-icon icon="print" class="pointer text-white" />
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <div class="d-flex align-items-center mt-5">
          <p class="title">สินค้า</p>
          <b-button
            class="text-right"
            :disabled="id > 0"
            @click="openSelectRepairProduct"
            >เลือก</b-button
          >
        </div>

        <div class="card p-3 mt-1">
          <b-row>
            <b-col md="6" cols="12">
              <div class="d-flex align-items-center mt-2 f-14">
                <p class="text-gray title-w">เลขที่ใบเสร็จ</p>
                <p class="text-gray">:</p>
                <a
                  class="ml-2 text-link"
                  :href="`/transaction/detail/${form.product.userTransactionId}/${form.repair_owner_user_guid}/1`"
                  >{{ form.product.invoiceNo }}</a
                >
              </div>
              <div class="d-flex align-items-center mt-2 f-14">
                <p class="text-gray title-w">วันที่ซื้อ</p>
                <p class="text-gray">:</p>
                <p class="ml-2">
                  {{
                    form.product.created_time
                      ? $moment(form.product.created_time).format("DD/MM/yyyy")
                      : ""
                  }}
                </p>
              </div>
              <div class="d-flex align-items-center mt-2 f-14">
                <p class="text-gray title-w">ชื่อสินค้า</p>
                <p class="text-gray">:</p>
                <a
                  class="ml-2 text-link"
                  :href="`/product/detail/${form.product.productId}`"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ form.product.name }}
                  {{
                    form.product.serial
                      ? `(Serial: ${form.product.serial})`
                      : ""
                  }}
                </a>
              </div>
              <div cols="12" class="mt-2">
                <div class="d-flex align-items-center f-14">
                  <div class="title-w text-gray">Weight</div>
                  <div class="">:</div>
                  <div class="ml-2">
                    {{ form.product.weight | numeral("0,.00") }}
                  </div>
                </div>
              </div>
            </b-col>
            <b-col md="6" cols="12" align-self="stretch">
              <div class="d-flex align-items-start mt-2 f-14">
                <p class="text-gray title-w">รูปสินค้า</p>
                <p class="text-gray mr-2">:</p>
                <div v-if="form.product.name">
                  <img
                    :src="form.product.imageUrl"
                    class="img-size"
                    v-if="form.product.imageUrl"
                  />
                  <img
                    v-else
                    src="@/assets/images/noimg.png"
                    alt="no-image-product"
                    class="img-size"
                  />
                </div>
              </div>
            </b-col>
          </b-row>

          <p class="title mt-3">ประวัติการซ่อม</p>
          <RepairLog :fields="fieldLog" :items="itemsLog" class="mt-2" />
        </div>
      </b-col>
      <b-col cols="12" md="4">
        <InputSelect
          :options="repairCauseList"
          v-model="form.repair_cause_id"
          @onDataChange="(val) => (form.repair_cause_id = val)"
          valueField="id"
          :v="$v.form.repair_cause_id"
          :isValidate="$v.form.repair_cause_id.$error"
          textField="name"
          title="สาเหตุชำรุด"
          :disabled="id > 0"
        >
          <template v-slot:option-first>
            <b-form-select-option :value="null" disabled
              >-- เลือกสาเหตุชำรุด --</b-form-select-option
            >
          </template>
        </InputSelect>
      </b-col>
      <b-col cols="12">
        <InputTextArea
          :disabled="form.repair_status_id > 0"
          v-model="form.remark"
          textFloat="หมายเหตุ"
          placeholder="หมายเหตุ"
          rows="3"
        >
        </InputTextArea>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="d-flex w-100">
          <b-row>
            <template>
              <b-col
                :key="'repair' + n"
                md="4"
                cols="12"
                v-for="(field, n) of fieldSetting"
              >
                <RepairCustomFields
                  :isDisabled="
                    form.repair_status_id > 0 || !field.is_editable_on_pos
                  "
                  :form="form.custom_field.answers"
                  :key="field.name"
                  :field="field"
                  :n="n"
                  @onAddImage="(images) => (field.value = images)"
                  :index="n"
                />
              </b-col>
            </template>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-between">
      <p class="title-detail mb-2">รายละเอียดการซ่อม</p>
      <div class="d-flex mt-2">
        <p class="mt-2 mr-2 title" style="flex: 1">EAN/Article</p>
        <InputText
          type="text"
          className=" bg-second input-w"
          placeholder="EAN/Article (บาร์โค้ด/ชื่อสินค้า)"
          textField=""
          v-model="searchArticle"
          @onEnter="searchProduct(searchArticle)"
          @onClickIcon="searchProduct(searchArticle)"
          :disabled="id > 0"
        />
        <font-awesome-icon
          @click="searchProduct(searchArticle)"
          :icon="['fas', 'search']"
          class="pointer fa-search text-white"
          id="search-icon"
        />
      </div>
    </div>
    <b-tabs v-model="tabIndex">
      <b-tab title="รายการซ่อม">
        <RepairList :items="form.items"></RepairList>

        <b-table
          v-if="rawtotalPrice && form.repair_status_id == 2"
          striped
          hover
          :busy="isBusy"
          :items="promotionItems"
          :fields="promotionFields"
          class="table-main table-custom"
          show-empty
          empty-text="No matching records found"
        >
          <template v-slot:cell(promotion)="{ item }">
            <InputSelect
              v-model="promotionForm[0].id"
              :options="promotionList"
              :disabled="form.billNo ? true : false"
              textField="name"
              valueField="id"
              @onDataChange="(val) => handleselectPro(val)"
              ><template v-slot:option-first>
                <b-form-select-option :value="null" disabled
                  >-- เลือกส่วนลด --</b-form-select-option
                >
              </template></InputSelect
            >
          </template>
          <template v-slot:cell(price)="data">
            <InputText
              placeholder="price"
              class="mb-2"
              :disabled="true"
              v-model="promotionForm[0].promotion_price"
              decimalPoint="2"
              type="text"
            ></InputText>
          </template>
          <template v-slot:cell(custom_header)="data">
            <div
              v-if="
                promotionForm[0].custom_header &&
                !form.repair_user_transaction_id
              "
              class="text-link"
              @click="showEditDiscount(promotionForm[0])"
            >
              ปรับส่วนลด
            </div>
          </template>
        </b-table>
      </b-tab>
      <b-tab title="โน๊ตการซ่อม" :disabled="id == 0">
        <label class="title mt-3">บันทึกภายใน</label>
        <b-card class="title mt-2">
          <div v-for="item in noteList">
            <p>
              {{ item.userFullName || "-" }}
              <span class="text-gray">{{
                $moment(item.created_time).format("DD/MM/YYYY (HH:mm) ")
              }}</span>
            </p>
            <div class="note mt-2" v-html="replaceCharacter(item.text)"></div>
            <template v-if="item.items.length > 0">
              <div class="text-bold mt-3">File Attachment</div>
              <div
                class="action-button cursor-pointer mr-2"
                v-for="(file, index) of item.items"
                :key="'file' + index"
                @click.prevent="openFile(file.data)"
              >
                <font-awesome-icon
                  icon="file"
                  title="file attachment"
                  class="mr-2"
                />
                <span class="f-12"> {{ file.mim_type }}</span>
              </div>
            </template>
            <hr />
          </div>
          <b-button class="ml-2 custom-btn" @click="isAddNote = true"
            ><font-awesome-icon
              icon="plus"
              title="create-btn"
              class="mr-0 mr-sm-1"
            />
            เพิ่มโน๊ต
          </b-button>

          <div v-if="isAddNote">
            <TextEditorsTiny
              textFloat=""
              :rows="4"
              :v="$v.note.text"
              :defaultEdit="false"
              :value="note.text"
              name="ticketNote"
              placeholder="Type something..."
              @onDataChange="(val) => (note.text = val)"
              :showTemplate="true"
              @addFileAttachment="addFileAttachment"
              addFile
              :isFixEdit="true"
            >
            </TextEditorsTiny>
            <div class="activity-footer">
              <b-button
                variant="outline-primary-color"
                class="btn-width"
                @click="cancelAddnote()"
                >Cancel</b-button
              >
              <b-button class="btn-primary-color btn-width" @click="sendNote()">
                Save
              </b-button>
            </div>
          </div>
        </b-card>
      </b-tab>
    </b-tabs>
    <b-modal
      ref="modalWarranty"
      hide-footer
      centered
      scroll-strategy="none"
      size="lg"
    >
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 align-items-center">
          กฏการรับประกัน
        </div>
      </template>
      <div class="mb-4 scroll-policy">
        <div class="mt-3" v-html="warranty"></div>
      </div>
    </b-modal>
    <h3 class="text-right mt-2">
      Total :
      {{
        this.promotionForm[0].promotion_value
          ? rawPrice
          : totalPrice | numeral("0,0.00")
      }}
    </h3>
    <FooterAction
      :routePath="'/repair-product'"
      @submit="confirmAlertModal()"
      :saveText="
        form.repair_status_id !== 2 &&
        (form.repair_user_transaction_id || !form.delivery_date)
          ? 'บันทึก'
          : totalPrice == 0
          ? 'ส่งมอบ'
          : 'ชำระเงิน'
      "
      :hideSubmit="
        (form.repair_status_id !== 2 ||
          form.repair_user_transaction_id ||
          (form.repair_status_id == 2 && form.delivery_date)) &&
        this.form.repair_status_id == 2
          ? true
          : false
      "
    ></FooterAction>
    <ModalAlertConfirm
      ref="modalAlertConfirm"
      :msg="confirmMessage.msg"
      :text="confirmMessage.text"
      @confirm="(val, test) => saveForm(val)"
    />
    <ModalRefundType
      ref="modalRefundtype"
      :userGuid="form.repair_owner_user_guid"
      @selectPayment="selectPayment"
    ></ModalRefundType>
    <ModalCustomerList
      ref="modalCustomerList"
      @setUserSelect="setUserSelect"
      :isRepair="true"
    />

    <ModalSearchRepairProduct
      :isRepair="true"
      :isMobile="isMobile"
      ref="modalSearchRepairProduct"
      @setSelectProduct="addRepairProduct"
    >
    </ModalSearchRepairProduct>
    <ModalSearchAllProduct
      :isRepair="true"
      :isMobile="isMobile"
      ref="modalProductList"
      @setSelectProduct="addProduct"
    ></ModalSearchAllProduct>
    <ModalRepairPayment
      ref="modalPayment"
      :paymentChannelList="paymentChannelList"
      @confirm="confirmPayment"
    ></ModalRepairPayment>
    <ModalBillDetails
      ref="modalBillDetails"
      :paymentChannelList="paymentChannelList"
      :isFullPos="isFullPos"
    />
    <ModalFormulaCalculation
      ref="modalFormulaCalculation"
      @success="addProduct"
    ></ModalFormulaCalculation>
    <ModalEditDiscount
      ref="modalEditDiscount"
      @success="calculateTransactionPromotion"
    ></ModalEditDiscount>
    <ModalPin
      v-if="id < 1 && require_pin_login == '0'"
      ref="ModalPin"
      @updateSaleId="updateSaleId"
    ></ModalPin>
  </div>
</template>
<script>
import FooterAction from "@/components/FooterAction";
import { mapGetters } from "vuex";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalAddProduct from "../requestPurchase/components/ModalAddProduct";
import ModalCustomerList from "../home/components/ModalCustomerList.vue";
import ModalRefundType from "./components/ModalRefundType.vue";
import RepairLog from "./components/RepairLog.vue";
import ModalSearchAllProduct from "./components/ModalSearchAllProduct.vue";
import RepairCustomFields from "./components/RepairCustomFields.vue";
import ModalSearchRepairProduct from "./components/ModalSearchRepairProduct.vue";
import RepairList from "./components/RepairList.vue";
import TextEditorsTiny from "@/components/inputs/TextEditorsTiny.vue";
import ModalRepairPayment from "./components/ModalRepairPayment.vue";
import ModalBillDetails from "../home/components/ModalBillDetails.vue";
import { required } from "vuelidate/lib/validators";
import ModalEditDiscount from "./components/ModalEditDiscount.vue";
import ModalFormulaCalculation from "./components/ModalFormulaCalculation.vue";
import ModalPin from "./components/ModalPin.vue";

export default {
  components: {
    FooterAction,
    ModalAlertConfirm,
    ModalAddProduct,
    ModalCustomerList,
    ModalRefundType,
    RepairLog,
    ModalSearchAllProduct,
    RepairCustomFields,
    ModalSearchRepairProduct,
    RepairList,
    TextEditorsTiny,
    ModalRepairPayment,
    ModalBillDetails,
    ModalEditDiscount,
    ModalFormulaCalculation,
    ModalPin,
  },
  validations() {
    return {
      form: {
        repair_cause_id: {
          required,
        },
      },
      note: {
        text: {
          required,
        },
      },
    };
  },

  data() {
    return {
      tabIndex: 0,
      isBusy: false,

      filter: {
        search: "",
        page: 1,
        take: 10,
        member: {
          search: "",
          searchType: 0,
        },
      },

      productList: [],

      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      items: [],
      rows: 0,
      id: this.$route.params.id,
      form: {
        inventory_product_serial_id: null,
        target_user_transaction_product_id: null,
        user_return_payment_id: 0,
        repair_cause_id: null,
        repair_owner_user_guid: "",
        repair_owner_user_name: "",
        repair_send_user_guid: "",
        repair_send_user_name: "",
        repair_reciever_user_name: "",
        repair_reciever_user_guid: "",
        remark: "",
        is_sell_back_scrap_gold: false,
        items: [],
        custom_field: {
          answers: [],
        },
        product: {},
        created_user_guid: "",
      },

      customerList: [],
      modalCallBack: () => {},
      modalMessage: "",
      isSaved: false,
      confirmMessage: {
        text: "",
        msg: "",
      },
      now: null,
      fieldLog: [
        {
          label: "เลขเอกสาร",
          key: "document_no",
          thStyle: { "min-width": "120px" },
        },
        {
          label: "วันที่รับเข้าซ่อม",
          key: "created_time",
          thStyle: { "min-width": "120px" },
        },
        {
          label: "หัวข้อการซ่อม",
          key: "name",
          thStyle: { "min-width": "120px" },
        },
        {
          label: "บันทึกการซ่อม",
          key: "remark",
          thStyle: { "min-width": "120px" },
        },
      ],

      itemsLog: [],
      repairCauseList: [],
      fieldsSerial: [
        { key: "name", label: "รายการ" },
        { key: "value", label: "น้ำหนักก่อนซ่อม" },
      ],
      isMobile: false,
      returnPayment: {},
      id: this.$route.params.id,
      fieldSetting: [],
      noteList: [],
      note: {
        repair_transaction_id: this.$route.params.id,
        text: "",
        items: [],
      },
      fileAttach: [],
      isAddNote: false,
      paymentChannelList: [],
      transaction: {},
      itemsSerialCustomField: [],
      searchArticle: "",
      warranty: "",
      productDetail: [],
      sendId: 0,
      payments: null,

      promotionFields: [
        { label: " ", key: "label", thStyle: { width: "250px" } },
        { label: " ", key: "promotion", thStyle: { width: "250px" } },
        { label: " ", key: "price", thStyle: { width: "250px" } },
        {
          label: " ",
          key: "custom_header",
          thStyle: { width: "250px" },
          class: "text-left",
        },

        { label: "", key: "action", thStyle: { width: "150px" } },
      ],
      promotionList: [],
      promotionItems: [
        {
          label: "ส่วนลดท้ายบิล",
          promotion: null,
        },
      ],
      promotionForm: [{ id: null, promotion_value: 0 }],
      rawPrice: 0,
    };
  },
  async created() {
    this.now = this.$moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    await this.getRepairCauseList();

    if (this.id > 0) {
      await this.getDetail();
      await this.getNote();
      if (this.form.repair_status_id == 2 && !this.form.billNo) {
        await this.getPromotionList();
      }
    }
    if (this.id == 0) {
      this.form.created_user_guid = this.$cookies.get("saleId");
    }
    await this.getFieldSetting();
  },

  computed: {
    totalPrice() {
      if (this.form.items.length && !this.rawPrice) {
        return this.form.items
          .reduce((sum, item) => sum + parseFloat(item.price || 0), 0)
          .toFixed(2);
      }
      return parseFloat(this.rawPrice || 0).toFixed(2);
    },
    rawtotalPrice() {
      return this.form.items.reduce(
        (sum, item) => sum + Number(item.price || 0),
        0
      );
    },
    ...mapGetters({
      mainLoading: "getMainLoading",
      userGuid: "getUserGuid",
      isFullPos: "getIsFullPos",
      branchId: "getBranchId",
      plantId: "getPlantId",
      salesNo: "getSalesNo",
      branchName: "getBranchName",
      branchType: "getBranchType",
      require_pin_login: "getRequirePin",
    }),
  },

  methods: {
    async getDetail() {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.$axios(
        `${this.$baseUrl}/repair/detail/${this.id}`
      );
      this.form = res.detail;
      this.form.items = this.form.items.map((x) => ({
        ...x,
        formatPrice: this.formatNum(x.price),
        formatCost: this.formatNum(x.cost),
      }));
      // await this.getHistory();
      let log = res.detail.history;

      if (this.form.billNo && this.form.promotion.length) {
        this.promotionList = this.form.promotion;
        this.promotionForm[0].promotion_price = this.form.billDiscount;
        this.promotionForm[0].id = this.form.promotion[0].id;
        if (this.form.billTotal) {
          this.rawPrice = this.form.billTotal;
        }
      }

      const addedFieldIds = new Set();

      log.forEach((item) => {
        if (item.fields && Array.isArray(item.fields)) {
          item.fields.forEach((field) => {
            const key = field.id.toString();
            if (!addedFieldIds.has(field.id)) {
              this.fieldLog.push({
                key: key,
                label: field.name,
                thStyle: { width: "200px" },
              });
              addedFieldIds.add(field.id);
            }
          });
        }
      });

      this.itemsLog = res.detail.history.map((item) => {
        const customFieldMap = {};

        if (item.fields && Array.isArray(item.fields)) {
          item.fields.forEach((answer, index) => {
            customFieldMap[answer.id] = {
              value: item.answers[index].item2 || "-",
              type: answer.field_type_id || "-",
            };
          });
        }
        const name = {
          name: {
            value: item.items ? item.items[0].name || "-" : "-",
          },
        };

        return {
          ...item,
          ...customFieldMap,
          ...name,
        };
      });

      if (this.form.repair_status_id == 2) {
        await this.getPaymentChannel();
      }

      await this.$store.dispatch("setMainLoading", false);
    },
    async getPromotionList() {
      let now = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      const res = await this.$axios(
        `${this.$baseUrl}/promotion/get_header_discount/${
          this.form.repair_owner_user_guid
        }/${this.$moment().format("YYYY-MM-DD HH:mm:ss")}/${this.branchId}`
      );
      this.promotionList = res.detail;
    },
    async getPaymentChannel() {
      await this.axios
        .get(`${this.$baseUrl}/Transaction/GetPaymentChannel`)
        .then(async (data) => {
          if (data.result == 1) {
            this.paymentChannelList = data.detail;
          }
        });
    },
    async getHistory() {
      const res = await this.$axios(
        `${this.$baseUrl}/repair/History/${this.form.repair_owner_user_guid}/${this.form.target_user_transaction_product_id}`
      );

      let log = res.detail.history;

      const addedFieldIds = new Set();

      log.forEach((item) => {
        if (item.fields && Array.isArray(item.fields)) {
          item.fields.forEach((field) => {
            const key = field.id.toString();
            if (!addedFieldIds.has(field.id)) {
              this.fieldLog.push({
                key: key,
                label: field.name,
                thStyle: { width: "200px" },
              });
              addedFieldIds.add(field.id);
            }
          });
        }
      });

      this.itemsLog = res.detail.history.map((item) => {
        const customFieldMap = {};

        if (item.fields && Array.isArray(item.fields)) {
          item.fields.forEach((answer, index) => {
            customFieldMap[answer.id] = {
              value: item.answers[index].item2 || "-",
              type: answer.field_type_id || "-",
            };
          });
        }
        const name = {
          name: {
            value: item.items[0].name || "-",
          },
        };

        return {
          ...item,
          ...customFieldMap,
          ...name,
        };
      });
    },

    async getFieldSetting() {
      const res = await this.$axios(`${this.$baseUrl}/repair/FieldSetting`);

      this.fieldSetting = res.detail.map((x) => {
        const answer = this.form.custom_field.answers.find(
          (a) => a.product_custom_field_id == x.id
        );
        let value = "";
        // if (x.field_type_id == 2) {
        //   value = [];
        // } else {
        //   value = "";
        // }

        if (answer) {
          value = answer.value;

          if (x.field_type_id == 2) {
            const splitArray = value.split(",");
            value = [...new Set(splitArray.map(Number))];
          }
        } else if (x.field_choices) {
          const defaultChoices = x.field_choices.filter(
            (f) => f.isDefault == 1
          );

          if (x.field_type_id == 2 && x.field_choices.length > 0) {
            const defaultIds = defaultChoices.map((f) => f.id);
            value = [...new Set([...defaultIds])];
          } else if (x.field_type_id == 4 || x.field_type_id == 3) {
            const firstDefault = defaultChoices[0];
            if (firstDefault) {
              value = firstDefault.id;
            }
          }
        }
        return {
          ...x,
          value,
        };
      });
    },
    async getRepairCauseList() {
      const res = await this.$axios(`${this.$baseUrl}/repair/RepairCause/List`);
      this.repairCauseList = res.detail.data;
    },
    async handleSearch(type) {
      this.customerList = [];
      if (this.id > 0) {
        return;
      }
      this.filter.member.searchType = type;
      this.$refs.modalCustomerList.show(this.filter.member.search);
    },
    async setUserSelect(user) {
      if (this.filter.member.searchType == 1) {
        this.form.repair_owner_user_name =
          user.first_name_th +
          " " +
          (user.last_name_th ? user.last_name_th : "");
        this.form.repair_owner_user_guid = user.user_guid;
        this.form.product = {};
        this.form.user_return_payment = {};
        this.form.user_return_payment_id = 0;
        this.itemsLog = [];
        await this.getUserReturnList();
        let payment = this.payments.find((x) => x.is_default);
        if (payment) {
          this.returnPayment = payment;
          this.form.user_return_payment = payment;
          this.form.user_return_payment_id = payment.id;
        }
        // this.form.repair_owner_user_member_id = user.member_id;
      } else {
        //Link input
        this.form.repair_send_user_name =
          user.first_name_th + " " + user.last_name_th;
        this.form.repair_send_user_guid = user.user_guid;
        this.form.repair_reciever_user_guid = user.user_guid;
        this.form.repair_reciever_user_name =
          user.first_name_th +
          " " +
          (user.last_name_th ? user.last_name_th : "");
      }
    },
    selectRefundType() {
      if (!this.form.repair_owner_user_guid) {
        return this.errorAlert("กรุณาเลือกชื่อลูกค้า");
      }
      this.$refs.modalRefundtype.show();
    },
    async confirmAlertModal() {
      if (this.form.repair_status_id == 2) {
        if (this.totalPrice > 0) return this.openModalPayment();
        else {
          this.confirmMessage = {
            msg: "ยืนยันการทำรายการ",
          };
          this.sendId = this.id;
          this.$refs.modalAlertConfirm.show(true);
        }
      }
      this.form.custom_field = {
        answers: this.fieldSetting.map((x) => ({
          product_custom_field_id: x.id,
          value: Array.isArray(x.value) ? `${x.value.join(",")}` : x.value,
        })),
      };

      this.$nextTick();
      this.$v.$touch();
      if (!this.form.created_user_guid) {
        return this.errorAlert("กรุณากรอกผู้สร้าง");
      } else if (!this.form.repair_send_user_name) {
        return this.errorAlert("กรุณาเลือกชื่อผู้ส่งซ่อม");
      } else if (!this.form.repair_owner_user_guid) {
        return this.errorAlert("กรุณาเลือกชื่อลูกค้า");
      } else if (!this.form.product.productId) {
        return this.errorAlert("กรุณาเลือกสินค้า");
      } else if (this.form.items.length == 0) {
        return this.errorAlert("กรุณาเลือกสินค้ารายการซ่อม");
      }
      // else if (!this.form.user_return_payment_id) {
      //   return this.errorAlert("กรุณาเลือกวิธีการรับเงิน");
      // }
      else if (!this.form.repair_cause_id) {
        return this.errorAlert("กรุณาเลือกสาเหตุชำรุด");
      } else {
        this.confirmMessage = {
          msg: "ยืนยันการทำรายการ",
        };
        this.$refs.modalAlertConfirm.show();
      }
    },
    async addProduct(product, flag = true) {
      if (product.price_calculation_model_id == 2 && flag)
        return await this.$refs.modalFormulaCalculation.show(product);
      this.form.items.push({
        ...product,
        formatPrice: this.formatNum(product.price),
        formatCost: "0.00",
        cost: 0,
        note: "",
      });
    },
    formatNum(value) {
      let formatVal = Number(value).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });
      if (!formatVal.includes(".") && value) {
        formatVal = formatVal + ".00";
      }
      return formatVal;
    },
    async addRepairProduct(product) {
      if (!this.form.repair_owner_user_guid) {
        this.form.repair_owner_user_guid = product.user_guid;
        this.form.repair_owner_user_name = product.user_name;
      }
      await this.$store.dispatch("setMainLoading", true);
      this.form.product = product;
      this.form.target_user_transaction_product_id =
        product.userTransactionProductId;
      await this.getSerialCustomField();
      await this.getHistory();
      await this.$store.dispatch("setMainLoading", false);
    },
    openSelectRepairProduct() {
      this.$refs.modalSearchRepairProduct.show(this.form);
    },
    selectPayment(payment) {
      this.returnPayment = payment;
      this.form.user_return_payment = payment;
      this.form.user_return_payment_id = payment.id;
    },
    async saveForm() {
      if (this.sendId) {
        await this.$store.dispatch("setMainLoading", true);
        const res = await this.$axios.post(
          `${this.$baseUrl}/repair/delivery/${this.id}`
        );
        if (res.result == 1) {
          this.successAlert(res.detail.message);
          await this.getDetail();
        } else {
          this.errorAlert(res.detail.message);
        }
        await this.$store.dispatch("setMainLoading", false);
        return;
      }
      if (this.id > 0) {
        await this.$store.dispatch("setMainLoading", true);
        const res = await this.$axios.put(`${this.$baseUrl}/repair/Update`, {
          ...this.form,
          inventory_product_serial_id:
            this.form.product.inventoryProductSerialId,
        });
        if (res.result == 1) {
          this.successAlert(res.detail.message),
            this.$router.push(`/repair-product/detail/${this.id}`);
        } else this.errorAlert(res.message);

        await this.$store.dispatch("setMainLoading", false);
        return;
      }
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.$axios.post(`${this.$baseUrl}/repair/Save`, {
        ...this.form,
        inventory_product_serial_id: this.form.product.inventoryProductSerialId,
      });
      if (res.result == 1) {
        this.successAlert(res.detail.message),
          this.exportTransaction(res.detail);
        this.$router.push(`/repair-product/detail/${res.detail}`);
      } else this.errorAlert(res.message);

      await this.$store.dispatch("setMainLoading", false);
    },
    async getSerialCustomField() {
      // await this.$store.dispatch("setMainLoading", true);
      // let res = await this.axios(
      //   `${this.$baseUrl}/repair/get_serial_detail/${this.form.product.inventoryProductSerialId}`
      // );
      // if (res.result) {
      //   this.form.serial_customfield = res.detail.serial_custom_field;
      //   this.itemsSerialCustomField =
      //     res.detail.serial_custom_field.answers[0].answer_detail || [];
      // } else {
      //   this.form.serial_customfield = [];
      //   this.itemsSerialCustomField = [];
      // }
      // await this.$store.dispatch("setMainLoading", false);
    },
    async searchProduct(search) {
      if (this.id > 0) {
        return;
      }
      this.$refs.modalProductList.show(this.form, this.searchArticle);
    },
    async getNote() {
      let res = await this.axios(`${this.$baseUrl}/repair/note/${this.id}`);
      this.noteList = res.detail;
    },
    async sendNote() {
      this.$v.note.$touch();
      if (this.$v.note.$error) return;
      await this.$store.dispatch("setMainLoading", true);
      let res = await this.axios.post(
        `${this.$baseUrl}/repair/note/save`,
        this.note
      );
      if (res.result) {
        this.isAddNote = false;
        this.note.text = "";
        this.note.items = [];
        this.$v.note.$reset();
        this.getNote();
      } else {
        this.errorAlert(res.message);
      }

      await this.$store.dispatch("setMainLoading", false);
    },
    addFileAttachment(list) {
      this.note.items = list;
    },
    replaceCharacter(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    cancelAddnote() {
      this.$v.note.$reset();
      this.note.text = "";
      this.note.items = [];
      this.isAddNote = false;
    },
    async openModalPayment() {
      if (!this.promotionForm[0].promotion_value) {
        await this.calculateTransaction();
      } else {
        await this.calculateTransactionPromotion();
      }

      this.$refs.modalPayment.show(
        this.form,
        this.transaction,
        this.productDetail,
        this.promotionForm[0]
      );
    },
    async calculateTransaction() {
      const res = await this.$axios(
        `${this.$baseUrl}/repair/calculate_transaction_data/${this.id}`
      );
      this.transaction = res.price;
      this.productDetail = res.detail;
    },
    async calculateTransactionPromotion() {
      await this.$store.dispatch("setMainLoading", true);
      let product = this.form.items.map((x) => ({
        product_group_barcode_id: 0,
        product_group_barcode: 0,
        name: x.name,
        gp_product_barcode: 0,
        id: x.product_id,
        q: 1,
        price: x.price,
        custom_price: null,
        group_barcode: "",
        sap_discount: [],
        item_discount: [],
        serial: null,
      }));
      let body = {
        price: [],
        promotion: [
          {
            ...this.promotionForm[0],
            promotion_value: Number(this.promotionForm[0].promotion_value),
          },
        ],
        credit: null,
        customer_id: this.form.repair_owner_user_guid,
        debug: 0,
        branch_id: this.branchId,
        t_datetime: this.now,
        user_get_point: 1,
        product: [...product],
      };
      const res = await this.$axios.post(
        `${this.$baseUrl}/transaction/calculate_transaction_data`,
        body
      );
      if (res.error_message) {
        (this.promotionForm = [{ promotion_value: 0, promotion_price: "" }]),
          (this.promotionItems[0].promotion = null);
        this.errorAlert(res.error_message);

        return await this.$store.dispatch("setMainLoading", false);
      }
      this.transaction = res.price;
      this.rawPrice = res.price.price;
      this.productDetail = res.detail;
      this.$set(
        this.promotionForm[0],
        "promotion_price",
        this.transaction.discount.toFixed(2)
      );

      await this.$store.dispatch("setMainLoading", false);
    },
    async handleselectPro(val) {
      this.promotionForm = this.promotionList.filter((x) => x.id == val);
      this.promotionItems[0].promotion = val;
      await this.calculateTransactionPromotion();
    },
    async confirmPayment(payment = null) {
      let product = this.form.items.map((prod, index) => {
        return {
          id: prod.product_id,
          q: 1,
          group_barcode: "",
          sap_discount: prod.sap_discount || [],
          item_discount: prod.item_discount || [],
          product_group_barcode: prod.product_group_barcode || 0,
          gp_product_barcode: prod.gp_product_barcode || 0,
          product_group_barcode_id: prod.barcode_group_id || 0,
          serial: prod.serial || "",
          custom_price: prod.price || 0,
        };
      });

      let credit = 0;
      // if (this.form.credit) {
      //   credit = { ...this.form.credit };
      //   credit.expired_date = this.$moment(credit.expired_date)
      //     .add(543, "years")
      //     .format("DD/MM/YYYY");
      // }
      let body = {
        price: [],
        promotion: this.promotionForm[0].promotion_value
          ? [
              {
                ...this.promotionForm[0],
                promotion_value: Number(this.promotionForm[0].promotion_value),
              },
            ]
          : [],
        product: product,
        // credit: credit,
        user_guid: this.form.repair_owner_user_guid,

        branch_id: this.branchId,
        t_datetime: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        sales_id: this.form.created_user_guid,
        invoice_no: this.form.invoiceNo,
        is_fullpos: this.isFullPos,
        user_get_point: 1,
        new_customer: "0",
        tourist: "0",
        partner: "0",
        partner_detail: "",
        zero_point: "0",
        payment_channel_id: payment ? payment.id : 1,
        payment_amount: payment ? payment.amount : 0,
        payments: payment ? payment.payments : [],
        note: payment.note,
      };

      await this.$store.dispatch("setMainLoading", true);
      await this.axios
        .post(
          `${this.$baseUrl}/repair/submit_transaction_data/${this.id}`,
          body
        )
        .then(async (data) => {
          await this.$store.dispatch("setMainLoading", false);
          if (data.result == 1) {
            if (this.isFullPos == 1) {
              this.axios.post("http://localhost:30033/api/PrintReceipt", {
                Base64String: data.print_file,
              });

              this.axios.get("http://localhost:30033/api/cashdrawer");
            }
            this.$refs.modalBillDetails.show(
              data,
              this.form.repair_owner_user_guid
            );
            await this.getDetail();
          } else {
            this.warningAlert(data.message);
          }
        });
    },
    async exportTransaction(transaction) {
      try {
        const response = await this.axios.get(
          `${this.$baseUrl}/repair/report/${transaction}`,
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response], { type: "application/pdf" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `repair-transaction-${transaction}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading PDF:", error);
      }
    },
    async printDoc(type) {
      let filePathe;
      let fileName;

      if (type == 1) {
        filePathe = this.form.document_file_path;
        fileName = this.form.document_no || "document";
      } else if (type == 2) {
        filePathe = this.form.sell_back_scrap_gold_file_path;
        fileName =
          this.form.sell_back_scrap_gold_document_no ||
          "sell-back-scrap-gold-document";
      } else if (type === 3 || type === 4) {
        const isSend = type === 3;
        const formData = isSend
          ? this.form.inventoryTransferSend
          : this.form.inventoryTransferReturn;

        const res = await this.axios.get(
          `${this.$baseUrl}/InvoiceConsignment/transfer/Report/${formData.id}/1`,
          { responseType: "blob" }
        );

        const blob = new Blob([res], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${formData.documentNo}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return;
      }

      try {
        const response = await fetch(filePathe);
        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    async getUserReturnList() {
      await this.axios(
        `${this.$baseUrl}/UserReturnPayment/list/${this.form.repair_owner_user_guid}`
      ).then(async (data) => {
        if (data.result == 1) {
          this.payments = data.detail.datas;
        }
      });
    },
    showEditDiscount(item) {
      this.$refs.modalEditDiscount.show(item, this.rawPrice);
    },
    updateSaleId(val) {
      this.form.created_user_guid = val.sales_no;
      this.form.created_user_name = val.sales_name;
    },
    showPin() {
      this.$refs.ModalPin.showModal = true;
      this.$refs.ModalPin.focusInput();
    },
    clearName() {
      this.form.repair_owner_user_name = "";
      this.form.repair_owner_user_guid = "";
      this.form.product = {};
      this.form.user_return_payment = {};
      this.form.user_return_payment_id = 0;
      this.itemsLog = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  color: #333 !important;
  font-size: 16x !important;
  font-weight: bold !important;
}

.title-w {
  width: 160px;
}

.display-user-value {
  border: #c9c8c8 1px solid;
  width: 230px;
  min-height: 30px;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  padding: 2px 10px;
  font-size: 14px;
  color: #404040;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    color: #404040;
    font-size: 10px;
  }
}

.fa-search {
  width: 32px;
  height: 32px;
  margin-left: 10px;
  border-radius: 50%;
  border: 1px none #fff;
  background-color: var(--primary-color) !important;
  padding: 5px 7px;
}
.custom-btn {
  height: 32px;
}

.calendar-icon {
  position: absolute;
  top: 20%;
  right: 3%;
}
.calendar-icon-top {
  top: 35% !important;
}
.datetime-container {
  position: relative;
  width: 230px;
}

.custom-date-picker ::v-deep input {
  height: 35px !important;
}

.space-bottom {
  padding-bottom: 80px;
}

.img-size {
  width: 200px;
  height: 200px;
}

.title-detail {
  color: #333 !important;
  font-size: 16x !important;
  font-weight: bold !important;
}

.input-w {
  width: 300px !important;
}

.activity-footer {
  display: flex;
  justify-content: flex-end;
  margin: 24px 0;
  gap: 8px;
}

.action-button {
  color: black;
  background-color: rgb(225 225 225);

  padding: 0.5rem;
  display: inline-flex;
  font-size: 16px;
  cursor: pointer;
}

.f-18px {
  font-size: 18px;
  font-weight: bold;
}
</style>
